function FNumberFormatKm(number) {
  // let whole = Math.floor(number).toString();
  let whole = (Math.round(number * 100) / 100).toString();
  whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return whole;
}

export default FNumberFormatKm;
